import { useLocation } from 'react-router-dom';
import { lastVisitedAtOptions } from '../../const';
import { useStore } from '../../context';
import { useEffectFirstSkip, useIsSmallScreen, useStatesWithFilterCounter } from '../../hooks';
import { showToRoles } from '../../utils';
import { BelongsToFilterSelects, Select } from '../select';
import { AppbarInputs } from './Appbar';
import { Actions } from '../../store';

const OverviewInputsBase = () => {
  const {
    state: {
      user: { data: user },
    },
    dispatch,
  } = useStore();

  const [states, setStates, filteredStates] = useStatesWithFilterCounter(
    {
      lastDays: 0,
      yardId: '',
    },
    {
      lastDays: 30,
    },
  );

  useEffectFirstSkip(() => {
    dispatch({ type: Actions.SET_REFRESH_PAGE });
  }, [JSON.stringify(filteredStates)]);

  const handleChange = (props: any) => {
    setStates('force', props);
  };

  return (
    <AppbarInputs className="appbar-inputs">
      {!showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'VENDOR'], user) && (
        <BelongsToFilterSelects
          handleChange={(data) => handleChange({ yardId: data.yardId })}
          filtersType="overview"
          withoutLabel
          isYardRequired
          isSubmitClicked
        />
      )}
      <Select
        options={lastVisitedAtOptions}
        value={states.lastDays}
        onChange={(e) => handleChange({ lastDays: e.target.value })}
      />
    </AppbarInputs>
  );
};

export const OverviewInputs = () => {
  const location = useLocation();
  const isSmallScreen = useIsSmallScreen();

  if (isSmallScreen || !location.pathname.includes('overview')) return <></>;

  return <OverviewInputsBase />;
};
